import React from "react";
import { useParams } from "react-router-dom";
import { bool } from "prop-types";
import InternalTransferTransactionPage from "./Internals/TransactionPage";
import OtherTransferTransactionPage from "./Others/TransactionPage";

const TransactionIndex = ({ isDesktop }) => {
    const { type } = useParams();

    return (
        <>
            {type === "internal" && <InternalTransferTransactionPage isDesktop={isDesktop} />}
            {type === "other" && <OtherTransferTransactionPage isDesktop={isDesktop} />}
        </>
    );
};

TransactionIndex.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransactionIndex;
